module.exports = __webpack_public_path__ + "img/儿茶.6fe8e105.jpg";